<template>
    <div
        class="flex items-center px-3 py-0.5 gap-1.5 rounded-full text-sm tracking-normal font-normal normal-case"
        :class="[bgColorClass, textColorClass]"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            bgColorClass: {
                type: String,
                default: 'bg-gray-300',
            },
            textColorClass: {
                type: String,
                default: 'text-gray-800',
            },
        },
    };
</script>
